var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMileageMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.951,
    height: 15.965,
    viewBox: "0 0 19.951 15.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mileage-meter",
    d: "M20.38,8.57l-1.23,1.85A8.06,8.06,0,0,1,18.93,18H5.07A8,8,0,0,1,15.58,6.85l1.85-1.23A10,10,0,0,0,3.35,19a2.03,2.03,0,0,0,1.72,1H18.92a2.041,2.041,0,0,0,1.74-1,10.09,10.09,0,0,0-.27-10.44l-.01.01Zm-9.79,6.84a2.032,2.032,0,0,0,2.83,0l5.66-8.49-8.49,5.66a2.03,2.03,0,0,0,0,2.83Z",
    transform: "translate(-2.033 -4.035)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileageMeter);
export default __webpack_public_path__ + "static/media/mileage-meter.5e3eae9ea51549c7fbde261052c09a38.svg";
export { ForwardRef as ReactComponent };